// extracted by mini-css-extract-plugin
module.exports = {"container":"Avatar_container__1v2p0","avatar":"Avatar_avatar__3UR-3"};